var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnmute = function SvgUnmute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.843 27.855v-1.429a6.06 6.06 0 0 0 3.132-2.305q1.188-1.67 1.188-3.766t-1.188-3.765a6.06 6.06 0 0 0-3.132-2.306v-1.429a7.5 7.5 0 0 1 4.089 2.765q1.58 2.074 1.58 4.735t-1.58 4.736a7.5 7.5 0 0 1-4.089 2.764m-9.332-5.172v-4.61h3.336L19.7 14.12v12.517l-3.853-3.954zm9.332 1.064v-6.783a3.5 3.5 0 0 1 1.405 1.428q.495.921.496 1.986 0 1.052-.5 1.957a3.6 3.6 0 0 1-1.4 1.412m-3.49-6.273-1.933 1.982H13.86v1.845h2.561l1.932 1.982z"
  })));
};
export default SvgUnmute;